import { useCameraStateContext } from "../../contexts/CameraContext";
import useBlock from "./useBlock";
import { useEffect } from "react";

function useBlockCamera () {
    const { panzone } = useCameraStateContext();

    const { getBlockInformation } = useBlock();

    const jumpToPosition = (x, y, cb = () => {}) => {
        panzone.pause();
        panzone.zoomTo(0, 0, 1 / panzone.getTransform().scale);
        panzone.smoothMoveTo(-(x) * panzone.getTransform().scale + 30, -(y - window.innerHeight / 2.5) * panzone.getTransform().scale, cb);
        panzone.resume();
    }

    const followBlock = (id) => {
        if(sessionStorage.getItem('reloaded') == 'true') {
            return sessionStorage.setItem('reloaded', 'false')
        }
        if(!id) return;
        
        const { block } = getBlockInformation(id);
        if(block == null) return;
        const completeMove = () => {
            const element = document.getElementById(id);
            if(!element) return;
            element.classList.add('selected')
        }
        jumpToPosition(block.x, block.y, completeMove);
    }

    const setPageHaveReload = () => {
        sessionStorage.setItem('reloaded', 'true');
    }

    useEffect(() => {
        window.followBlock = followBlock;
    
        window.addEventListener("beforeunload", setPageHaveReload);
    
        return () => {
            window.removeEventListener('beforeunload', setPageHaveReload)
        }

    }, [panzone])

    return { jumpToPosition, followBlock };
}

export default useBlockCamera;